var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09155 0.122669C7.71384 -0.039425 7.28616 -0.0394247 6.90845 0.122669L2.40845 2.05384C1.85728 2.29037 1.5 2.83249 1.5 3.43227V7.13239C1.5 8.74558 2.23966 10.2695 3.50644 11.2661L6.57327 13.679C7.11719 14.107 7.88282 14.107 8.42673 13.679L11.4936 11.2661C12.7603 10.2695 13.5 8.74558 13.5 7.13239V3.43227C13.5 2.83249 13.1427 2.29037 12.5916 2.05384L8.09155 0.122669ZM3 3.76365C3 3.56372 3.11909 3.38301 3.30282 3.30417L7.30282 1.58758C7.42872 1.53354 7.57128 1.53354 7.69718 1.58758L11.6972 3.30417C11.8809 3.38301 12 3.56372 12 3.76365V7.13239C12 8.28467 11.4717 9.37315 10.5668 10.0851L7.5 12.498L4.43317 10.0851C3.52833 9.37315 3 8.28467 3 7.13239V3.76365ZM4.80493 7.62611L6.21981 9.0429C6.61044 9.43405 7.24434 9.43405 7.63497 9.0429L10.6406 6.03322C10.9332 5.74025 10.9332 5.26568 10.6406 4.97272C10.3475 4.6792 9.87181 4.6792 9.57868 4.97272L6.92739 7.62757L5.86685 6.56561C5.57373 6.27209 5.09805 6.27209 4.80493 6.56561C4.51236 6.85857 4.51236 7.33315 4.80493 7.62611Z",
    fill: "#3AB56C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.82fb9fae94c10a436ef38242ef9376a2.svg";
export { ForwardRef as ReactComponent };